import type { EntityConfig } from '../types'

export const creditEntity: EntityConfig = {
  id: 'credit',
  displayName: 'Credit',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'expired', label: 'Expired' },
      { value: 'depleted', label: 'Depleted' },
      { value: 'voided', label: 'Voided' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'expired', label: 'Expired', color: 'error' },
      { value: 'depleted', label: 'Depleted', color: 'neutral' },
      { value: 'voided', label: 'Voided', color: 'error' },
      { value: 'draft', label: 'Draft', color: 'warning' },
    ],
    mappings: {
      all: ['active', 'expired', 'depleted', 'voided', 'draft'],
      active: ['active'],
      expired: ['expired'],
      depleted: ['depleted'],
      voided: ['voided'],
      draft: ['draft'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'status',
    'dateRange',
    'search',
  ]
}
